import React, { Component, createRef } from 'react';
import moment from 'moment';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import { CommonSuccessMessages, CommonValidationMessages } from '../../utils/Messages.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import SecondPageReceiptPaymentEntry from '../../components/account/SecondPageReceiptPaymentEntry.js';
import FirstPageReceiptPaymentEntry from '../../components/account/FirstPageReceiptPaymentEntry.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import Cheque from '../../components/cheque/Cheque.js';
import numBerToWord from 'number-to-words'

class PaymentEntry extends Component {
    constructor(props) {
        super(props);
        this.printRef = createRef();
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            index: null,
            isGridView: true,
            isChequePrint: false,
            isLoading: false,
            tableStatus: "",
            isadjustmentDetailsEditing: false,
            isDisabledAdjustmentFields: true,
            setPendingInvoiceModal: false,
            partyDropdownList: [],
            paymentEntryList: [],
            daybookList: [],
            pendingInvoiceList: [],
            adjustmentDetailsList: [],
            pageName: "paymentEntry",
            filterDetails: {
                search: "",
                arrangedBy: "",
                from: 'PaymentEntry'
            },
            paymentDetails: {
                paymentReceiptId: "",
                voucherNo: "",
                date: "",
                partyId: "",
                partyBankNameOrPayto: "",
                closingBalance: "",
                bankName: "",
                bankId: "",
                chqNo: "",
                debitAmount: "",
                amount: "",
                narration1: "",
                narration2: "",
                narration3: "",
                narration4: "",
                maintainAc: "",
                pendingAmount: 0,
                entryType: "Paymnet",
                from: "PaymentEntry",
                amountInWords: "",
                partyName: "",
            },
            adjustmentDetails: {
                adjType: "",
                invoiceNo: "",
                invoiceAmount: "0",
                adjAmount: "0",
                gstPurchaseEntryRMPMId: null,
                gstPurchaseEntryWithoutInventoryId: null,
                grandTotalAmountInvoice: 0,
            },
            arrangedByList: [
                { arrangedBy: "Voucher No.", value: "voucherNo" },
                { arrangedBy: "Date", value: "date" },
                { arrangedBy: "Party Name", value: "partyName" },
                { arrangedBy: "Cheque No", value: "chequNo" },
                { arrangedBy: "Amount.", value: "amount" },
            ],
            bankList: [
                { bankName: "DTDC", value: "dtdc" },
                { bankName: "MADHUR", value: "madhur" },
                { bankName: "SPEED POST", value: "speedPost" },
                { bankName: "TRACKON", value: "trackOn" },
                { bankName: "OTHER", value: "other" },
            ],
            adjTypeList: [
                { adjType: "Adj. Ref", value: "adjRef" },
                { adjType: "On A/C", value: "onA/C" },
            ],
            validationRules: {
                date: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "date"
                        ),
                    },
                ],
                bankId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "Bank Name"
                        ),
                    },
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "party name"
                        ),
                    },
                ],
                debitAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "amount"
                        ),
                    },
                ],

            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRulesForAdjustmentDetails: {
                adjType: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "adjustment type"
                        ),
                    },
                ],
                adjAmount: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "adjustment amount"
                        ),
                    },
                    {
                        type: "number",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "adjustment amount"
                        ),
                    },
                    {
                        type: "graterThenZero",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "adjustment amount"
                        ),
                    },
                ],
            },
            validStateForAdjustmentDetails: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        this.getAllPaymnetEntry()
    }

    getAllPaymnetEntry = () => {
        this.setState({ tableStatus: "Loading..." })
        let request = this.state.filterDetails
        this.accountServices.getAllPaymnetEntry(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                if (response.responseData.length === 0) {
                    this.setState({ tableStatus: "No Record Found" })
                } else {
                    this.setState({ tableStatus: "" })
                }
                this.setState({ paymentEntryList: response.responseData }, () => {
                    this.getAllPartyDropdown()
                })
            } else {
                this.setState({ tableStatus: "" })
                this.getAllPartyDropdown();
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllPartyDropdown = () => {
        this.commonServices.getAllPartyDropdown().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData;
                let dropdownItems = res.map((item) => ({
                    label: item.partyName,
                    value: item._id,
                    maintainAc: item.maintainAc,
                }));
                this.setState({ partyDropdownList: dropdownItems }, () => {
                    this.getAllDaybooks()
                });
            } else {
                this.getAllDaybooks()
                this.SwalServices.Error(response.Message);
            }
        });
    };

    getAllDaybooks = () => {
        let request = ''
        this.commonServices.getAllDaybooks(request).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                const filteredBooks = response.responseData.filter(book => book.bookType === "Bank Book" || book.bookType === "Cash Book");
                let dropdownItems = filteredBooks.map((item) => ({
                    label: item.daybookName,
                    value: item._id,
                }));
                console.log(dropdownItems)
                this.setState({ daybookList: dropdownItems });
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    };

    addEditPaymentEntry = () => {
        let isValidAllFields = this.isValidAllFields();
        if (isValidAllFields) {
            this.setState({ isLoading: true }, () => {
                if (Number(this.state.paymentDetails.pendingAmount) === 0) {
                    let request = {
                        paymentDetails: this.state.paymentDetails,
                        adjustmentDetailsList: this.state.adjustmentDetailsList
                    }
                    this.accountServices.addEditPaymentEntry(request).then((response) => {
                        if (response.statusCode === 200 && response.responseData != null) {
                            this.SwalServices.Success(response.Message);
                            this.setState({ isGridView: true, isLoading: false }, () => {
                                this.resetForm()
                                let details = this.state.paymentDetails
                                details.amountInWords = Number(details.debitAmount) > 0 ?
                                    numBerToWord.toWords(details.debitAmount).replace(/,/g, '').replace(/\b\w/g, char => char.toUpperCase()) + ' Only' : '';
                                this.setState({ paymentDetails: details })
                                this.setState({ isChequePrint: true })
                            })
                        } else {
                            this.setState({ isLoading: false })
                            this.SwalServices.Error(response.Message);
                        }
                    });
                } else {
                    this.setState({ isLoading: false })
                    this.SwalServices.Alert('Please Adjust the Amount Properly')
                }
            })
        }
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.paymentDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };

    closeGridView = () => {
        this.setState({ isGridView: false });
    };

    openGridView = () => {
        this.resetForm();
        this.resetAdjustmentDetails()
        this.setState({ isGridView: true, isEditing: false });
    };

    resetAdjustmentDetails = () => {
        let validState = this.state.validStateForAdjustmentDetails
        validState.error = {}
        validState.isValid = true

        let adjustmentDetails = this.state.adjustmentDetails
        adjustmentDetails.adjType = ""
        adjustmentDetails.invoiceNo = ""
        adjustmentDetails.invoiceAmount = "0"
        adjustmentDetails.adjAmount = "0"
        adjustmentDetails.gstPurchaseEntryRMPMId = ""
        adjustmentDetails.gstPurchaseEntryWithoutInventoryId = ""

        this.setState({ adjustmentDetails: adjustmentDetails, validStateForAdjustmentDetails: validState });
    }

    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}

        let filterDetails = this.state.filterDetails
        filterDetails.search = ""
        filterDetails.arrangedBy = ""

        let paymentDetails = this.state.paymentDetails
        paymentDetails.date = ""
        paymentDetails.voucherNo = ""
        paymentDetails.partyId = ""
        paymentDetails.closingBalance = ""
        paymentDetails.partyBankNameOrPayto = ""
        paymentDetails.bankName = ""
        paymentDetails.chequeNo = ""
        paymentDetails.amount = ""
        paymentDetails.narration1 = ""
        paymentDetails.narration2 = ""
        paymentDetails.narration3 = ""
        paymentDetails.narration4 = ""
        paymentDetails.debitAmount = ""
        paymentDetails.bankId = ""
        paymentDetails.paymentReceiptId = ""
        paymentDetails.pendingAmount = 0

        this.setState({ filterDetails: filterDetails, paymentDetails: paymentDetails, validState: validState, adjustmentDetailsList: [] }, () => {
            this.getAllPaymnetEntry()
        }, () => {
            this.resetAdjustmentDetails()
        });
    }
    handleChange = (event, name, section) => {
        let value = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = value.toUpperCase();
            this.setState({ filterDetails: details }, () => {
                this.getAllPaymnetEntry()
            });
        }
        else if (section === "accountDetails") {
            let details = this.state.paymentDetails;
            details[name] = value.toUpperCase();
            if (this.state.paymentDetails.maintainAc === 'B' && name === 'debitAmount' && Number(details.debitAmount) > 0) {
                this.setState({ isDisabledAdjustmentFields: false })
                details.pendingAmount = details.debitAmount
                if (this.state.adjustmentDetailsList.length > 0) {
                    this.setState({ adjustmentDetailsList: [] })
                }
            }
            this.setState({ paymentDetails: details });
        }
        else if (section === "adjustmentDetails") {
            let details = this.state.adjustmentDetails;
            details[name] = value.toUpperCase();
            this.setState({ adjustmentDetails: details });
        }
    };
    handleDropDownChange = (event, name, section) => {
        const select = event.target.value;
        if (section === "filterDetails") {
            let details = this.state.filterDetails;
            details[name] = select;
            this.setState({ filterDetails: details }, () => {
                this.getAllPaymnetEntry()
            });
        }
        else if (section === "accountDetails") {
            let details = this.state.paymentDetails;
            details[name] = select;
            this.setState({ paymentDetails: details });
        }
        else if (section === "adjustmentDetails") {
            let details = this.state.adjustmentDetails;
            details[name] = select;
            this.setState({ adjustmentDetails: details }, () => {
                if (name === 'adjType' && select === 'Adj. Ref') {
                    this.getAllPendingInvoiceForPaymentEntryByPartyId(this.state.paymentDetails.partyId)
                } else {
                    let details = this.state.adjustmentDetails
                    details.invoiceNo = ''
                    details.invoiceAmount = '0'
                    details.adjAmount = '0'
                    details.gstPurchaseEntryRMPMId = null
                    details.gstPurchaseEntryWithoutInventoryId = null
                    this.setState({ adjustmentDetails: details })
                }
            });
        }
    };

    getAllPendingInvoiceForPaymentEntryByPartyId = (id) => {
        this.accountServices.getAllPendingInvoiceForPaymentEntryByPartyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let list = this.state.adjustmentDetailsList
                let res = response.responseData
                if (list.length > 0 && res.length > 0) {
                    let mergedArray1 = list.reduce((acc, item) => {
                        let keyRMPM = item.gstPurchaseEntryRMPMId;
                        let keyWithoutInventory = item.gstPurchaseEntryWithoutInventoryId;

                        if (keyRMPM) {
                            acc[keyRMPM] = (acc[keyRMPM] || 0) + Number(item.adjAmount);
                        }
                        if (keyWithoutInventory) {
                            acc[keyWithoutInventory] = (acc[keyWithoutInventory] || 0) + Number(item.adjAmount);
                        }

                        return acc;
                    }, {});

                    let resultArray = Object.keys(mergedArray1).map(id => ({
                        gstPurchaseEntryId: id,
                        adjAmount: mergedArray1[id]
                    }));

                    res.forEach(item2 => {
                        let found = resultArray.find(item1 =>
                            item1.gstPurchaseEntryId === item2.gstPurchaseEntryRMPMId ||
                            item1.gstPurchaseEntryId === item2.gstPurchaseEntryWithoutInventoryId
                        );
                        if (found) {
                            item2.pendingAmount -= found.adjAmount;
                        }
                    });

                    res = resultArray.filter(item => item.adjAmount > 0);
                }

                this.setState({ pendingInvoiceList: response.responseData }, () => {
                    this.setState({ setPendingInvoiceModal: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    setFilterParameters = (selected, drpIdentity, section) => {
        let details = this.state.paymentDetails;
        details[drpIdentity] = selected.value;
        if (drpIdentity === 'partyId') {
            details.maintainAc = selected.maintainAc
            details.partyName = selected.label
            this.getRunningBalanceByPartyId(selected.value)
        }
        this.setState({ paymentDetails: details }, () => {
            if (this.state.paymentDetails.maintainAc === 'B' && Number(this.state.paymentDetails.debitAmount) > 0) {
                this.setState({ isDisabledAdjustmentFields: false })
            }
        });
    };

    getRunningBalanceByPartyId = (id) => {
        this.accountServices.getRunningBalanceByPartyId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let closingBalance = JSON.stringify(response.responseData.closingBalance)
                let closingBalanceDRCR = response.responseData.closingBalanceDRCR
                let details = this.state.paymentDetails
                details.closingBalance = closingBalance + ' ' + closingBalanceDRCR
                this.setState({ paymentDetails: details })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    getPaymentEntryVoucherNo = () => {
        this.accountServices.getPaymentEntryVoucherNo().then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let details = this.state.paymentDetails
                details.voucherNo = response.responseData.voucherNo
                details.date = moment(new Date()).format('yyyy-MM-DD')
                this.setState({ paymentDetails: details }, () => {
                    this.closeGridView()
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    setOpenModel = () => {
        this.setState({ setPendingInvoiceModal: !this.state.setPendingInvoiceModal });
    };

    selectInvoiceFromPendingInvoice = (item) => {
        let adjustmentDetails = this.state.adjustmentDetails
        adjustmentDetails.invoiceAmount = item.pendingAmount
        adjustmentDetails.invoiceNo = item.invoiceNo
        adjustmentDetails.gstPurchaseEntryRMPMId = item.gstPurchaseEntryRMPMId ? item.gstPurchaseEntryRMPMId : null
        adjustmentDetails.gstPurchaseEntryWithoutInventoryId = item.gstPurchaseEntryWithoutInventoryId ? item.gstPurchaseEntryWithoutInventoryId : null
        adjustmentDetails.grandTotalAmountInvoice = item.grandTotal
        if (Number(item.pendingAmount) >= Number(this.state.paymentDetails.debitAmount)) {
            adjustmentDetails.adjAmount = this.state.paymentDetails.debitAmount
        } else if (Number(item.pendingAmount) < Number(this.state.paymentDetails.debitAmount)) {
            adjustmentDetails.adjAmount = item.pendingAmount
        }

        if (this.state.adjustmentDetailsList.length > 0 && Number(item.pendingAmount) !== Number(adjustmentDetails.adjAmount)) {
            let pendingAmount = this.state.adjustmentDetailsList.reduce((sum, item) => sum + Number(item.adjAmount), 0);
            adjustmentDetails.adjAmount = adjustmentDetails.adjAmount - pendingAmount
        }

        this.setState({ adjustmentDetails: adjustmentDetails }, () => {
            this.setState({ setPendingInvoiceModal: false })
        })
    }

    saveDatainAdjustmentTable = () => {
        let list = [...this.state.adjustmentDetailsList];
        let details = { ...this.state.adjustmentDetails };
        let isValidAllFieldsForAdjustmentDetails = this.isValidAllFieldsForAdjustmentDetails()
        if (isValidAllFieldsForAdjustmentDetails) {
            if (this.state.index >= 0 && this.state.index !== null && this.state.index !== undefined) {
                list[this.state.index] = details
            } else {
                list.push(details);
            }
            this.setState({ adjustmentDetailsList: list, index: null, isadjustmentDetailsEditing: false }, () => {
                this.calculatePendingAmount()
            })
        }
    };

    calculatePendingAmount = () => {
        let list = this.state.adjustmentDetailsList
        let pendingAmount = list.reduce((sum, item) => sum + Number(item.adjAmount), 0);
        let paymentDetails = this.state.paymentDetails
        paymentDetails.pendingAmount = Number(paymentDetails.debitAmount) - Number(pendingAmount)
        this.setState({ paymentDetails: paymentDetails }, () => {
            this.resetAdjustmentDetails()
        })
    }

    isValidAllFieldsForAdjustmentDetails = () => {
        const newValidState = isValidForm(
            this.state.adjustmentDetails,
            this.state.validationRulesForAdjustmentDetails,
            this.state.validStateForAdjustmentDetails
        );
        this.setState({ validStateForAdjustmentDetails: newValidState });
        return newValidState.isValid;
    };

    editAdjustmentDetails = (index, item) => {
        let details = this.state.adjustmentDetails
        details.adjAmount = item.adjAmount
        details.invoiceNo = item.invoiceNo
        details.adjType = item.adjType
        details.invoiceAmount = item.invoiceAmount
        details.gstPurchaseEntryRMPMId = item.gstPurchaseEntryRMPMId ? item.gstPurchaseEntryRMPMId : null
        details.gstPurchaseEntryWithoutInventoryId = item.gstPurchaseEntryWithoutInventoryId ? item.gstPurchaseEntryWithoutInventoryId : null
        this.setState({ adjustmentDetails: details, index: index, isadjustmentDetailsEditing: true })
    }

    deleteAdjustmentDetails = (index) => {
        let list = [...this.state.adjustmentDetailsList];
        list.splice(index, 1);
        this.setState({ adjustmentDetailsList: list }, () => {
            this.calculatePendingAmount()
        });
    }

    getPaymentDetailsByPaymnetReceiptId = (id) => {
        this.accountServices.getPaymentDetailsByPaymnetReceiptId(id).then((response) => {
            if (response.statusCode === 200 && response.responseData != null) {
                let res = response.responseData
                let details = this.state.paymentDetails
                details.voucherNo = res.paymentDetails.voucherNo
                details.date = moment(res.paymentDetails.date).format('yyyy-MM-DD')
                details.partyId = res.paymentDetails.partyId
                details.partyBankNameOrPayto = res.paymentDetails.partyBankNameOrPayto
                details.bankId = res.paymentDetails.bankId ? res.paymentDetails.bankId : ""
                details.chqNo = res.paymentDetails.chqNo
                details.debitAmount = Number(res.paymentDetails.debitAmount).toFixed(2)
                details.narration1 = res.paymentDetails.narration1
                details.narration2 = res.paymentDetails.narration2
                details.narration3 = res.paymentDetails.narration3
                details.paymentReceiptId = res.paymentDetails._id
                details.amountInWords = numBerToWord.toWords(res.paymentDetails.debitAmount).replace(/,/g, '').replace(/\b\w/g, char => char.toUpperCase()) + ' Only';
                details.partyName = this.state.partyDropdownList.find(
                    (party) => party.value === res.paymentDetails.partyId).label
                let list = res.adjustmentDetailsList
                list.map(item => {
                    item.isFromDB = true
                    return item
                })

                if (res.adjustmentDetailsList.length > 0) {
                    this.setState({ isDisabledAdjustmentFields: false })
                }
                this.setState({ paymentDetails: details, adjustmentDetailsList: list }, () => {
                    this.setState({ isGridView: false, isChequePrint: true })
                })
            } else {
                this.SwalServices.Error(response.Message);
            }
        });
    }

    deletePaymentDetailsByPaymentReceiptId = (id) => {
        this.SwalServices.Confirm(
            "",
            ``,
            CommonSuccessMessages.Yes_Text,
            CommonSuccessMessages.No_Text,
            `Are you sure you want to delete this Payment ?`
        ).then((response) => {
            if (response === true) {
                this.accountServices.deletePaymentDetailsByPaymentReceiptId(id).then((response) => {
                    if (response.statusCode === 200 && response.responseData != null) {
                        this.getAllPaymnetEntry()
                        this.SwalServices.Success(response.Message);
                    } else {
                        this.SwalServices.Error(response.Message);
                    }
                });
            }
        });
    }

    printCheque = () => {
        const printContent = this.printRef.current;
        const originalContent = document.body.innerHTML;

        document.body.innerHTML = printContent.innerHTML;
        window.print();

        document.body.innerHTML = originalContent;
        window.location.reload();
    };

    render() {
        return (
            <div className='paymentEntry-page'>
                {/* First Page  */}
                {this.state.isGridView === true ? (
                    <FirstPageReceiptPaymentEntry
                        filterDetails={this.state.filterDetails}
                        arrangedByList={this.state.arrangedByList}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        closeGridView={this.closeGridView.bind(this)}
                        getVoucherNo={this.getPaymentEntryVoucherNo.bind(this)}
                        receiptEntryList={this.state.paymentEntryList}
                        getReceiptDetailsByReceiptId={this.getPaymentDetailsByPaymnetReceiptId.bind(this)}
                        deleteReceiptDetailsByReceiptId={this.deletePaymentDetailsByPaymentReceiptId.bind(this)}
                        pageName={this.state.pageName}
                        tableStatus={this.state.tableStatus}
                    />
                ) : null}

                {/* Second Page  */}
                {this.state.isGridView === false ? (
                    <SecondPageReceiptPaymentEntry
                        pageName={this.state.pageName}
                        accountDetails={this.state.paymentDetails}
                        adjustmentDetails={this.state.adjustmentDetails}
                        handleChange={this.handleChange.bind(this)}
                        handleDropDownChange={this.handleDropDownChange.bind(this)}
                        bankList={this.state.bankList}
                        adjTypeList={this.state.adjTypeList}
                        setFilterParameters={this.setFilterParameters.bind(this)}
                        partyDropdownList={this.state.partyDropdownList}
                        openGridView={this.openGridView.bind(this)}
                        validationRules={this.state.validationRules}
                        validState={this.state.validState}
                        addEditEntry={this.addEditPaymentEntry.bind(this)}
                        resetForm={this.resetForm.bind(this)}
                        resetAdjustmentDetails={this.resetAdjustmentDetails.bind(this)}
                        daybookList={this.state.daybookList}
                        isDisabledAdjustmentFields={this.state.isDisabledAdjustmentFields}
                        setOpenModel={this.setOpenModel.bind(this)}
                        setPendingInvoiceModal={this.state.setPendingInvoiceModal}
                        pendingInvoiceList={this.state.pendingInvoiceList}
                        selectInvoiceFromPendingInvoice={this.selectInvoiceFromPendingInvoice.bind(this)}
                        saveDatainAdjustmentTable={this.saveDatainAdjustmentTable.bind(this)}
                        adjustmentDetailsList={this.state.adjustmentDetailsList}
                        validStateForAdjustmentDetails={this.state.validStateForAdjustmentDetails}
                        editAdjustmentDetails={this.editAdjustmentDetails.bind(this)}
                        isadjustmentDetailsEditing={this.state.isadjustmentDetailsEditing}
                        deleteAdjustmentDetails={this.deleteAdjustmentDetails.bind(this)}
                        printCheque={this.printCheque.bind(this)}
                        isChequePrint={this.state.isChequePrint}
                        isLoading={this.state.isLoading}
                    />
                ) : null}
                <div
                    ref={this.printRef}
                    className='hidden print:block'
                >
                    <Cheque
                        amount={this.state.paymentDetails.debitAmount}
                        amountInWords={this.state.paymentDetails.amountInWords}
                        date={moment(this.state.paymentDetails.date).format('DD MM YYYY')}
                        partyName={this.state.paymentDetails.partyName}
                        accountType='A/C Payee Only'
                    />
                </div>
            </div>
        );
    }
}

export default PaymentEntry;